import { useBalance } from '~/components/Balance/Balance.hooks';
import { DonIcon } from '~/components/Icon/Don';
import { Don, DonProps } from '../Don';
import './DonBalance.scss';

export type DonBalanceProp = {
  icon?: boolean;
  value?: number;
  format?: DonProps['format'];
};

export const DonBalance = ({ icon = false, value, format }: DonBalanceProp) => {
  const { data: { amount = 0 } = {} } = useBalance({
    useErrorBoundary: false,
    enabled: value === undefined,
  });

  return (
    <span className="don-balance">
      {icon && <DonIcon />}
      <Don value={value ?? amount} format={format} />
    </span>
  );
};
